var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wangeditor"},[_c('div',{ref:"toolbar",staticClass:"toolbar"}),_c('div',{ref:"wangeditor",staticClass:"text"})])
}
var staticRenderFns = []

export { render, staticRenderFns }